/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Jahreshinzurechnungsbetrag1Inputs */



/**

* @param {_Field_Jahreshinzurechnungsbetrag1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_jahreshinzurechnungsbetrag1 = /** @type {((inputs?: _Field_Jahreshinzurechnungsbetrag1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Jahreshinzurechnungsbetrag1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Jahreshinzurechnungsbetrag")
});
export { _field_jahreshinzurechnungsbetrag1 as "_field_jahresHinzurechnungsbetrag" }